import { useAuthToken } from "@xapp/components";
import { Credentials } from "auth";
import { useSelector } from "react-redux";
import { State } from "redux/state";
import { useSingleHashStringParam } from "utils/url";


/**
 * Returns the access token from state.auth.credentials.
 * @returns
 */
export function useAccessToken(): string {
    const auth = useSelector<State, Credentials>(state => state.auth.credentials);

    const storedToken = useAuthToken()[0];

    const urlAccessToken = useSingleHashStringParam("access_token");

    const accessToken = auth?.accessToken || storedToken?.value?.accessToken || urlAccessToken;

    return accessToken;
}